import { render } from "./HomeProperty.vue?vue&type=template&id=54cd92c2&scoped=true"
import script from "./HomeProperty.vue?vue&type=script&lang=js"
export * from "./HomeProperty.vue?vue&type=script&lang=js"

import "./HomeProperty.vue?vue&type=style&index=0&id=54cd92c2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd92c2"]])

export default __exports__